import { useAlert } from "@apex/component-library";
import { useQuery } from "react-query";

import { MenuItem } from "../types";
import { fetchMenuItems } from "../utils/fetchMenuItems";

export const useMenuItemsQuery = () => {
  const { setAlert } = useAlert();
  return useQuery<MenuItem[]>({
    queryKey: "menuItems",
    queryFn: () => fetchMenuItems(),
    refetchOnWindowFocus: false,
    retry: false,
    onError: () => {
      setAlert({
        variant: "error",
        description: "Error fetching Menu Items",
        title: "Error",
        isClosable: true,
      });
    },
  });
};
